import React, {Component, Fragment}  from 'react'
import { connect } from 'react-redux'
import { NavLink, withRouter } from 'react-router-dom';

import {  doLogout } from '../../../redux/auth/actions';

import classes from './Toolbar.module.scss';
import Burger from 'react-css-burger';

import Media from 'react-media';


const bgAccount=require('../../../assets/img/account.svg');
const bgLogout=require('../../../assets/img/logout.svg');

class Toolbar extends Component {

    render(){
        return(
        <header className={classes.Toolbar}>
            <div className={classes.Logo}>
            <NavLink exact to="/"><img  alt="" src={require('../../../assets/img/logo.svg')} /></NavLink>
            </div>
    
            <nav>
                <NavLink activeClassName={classes.active} exact to="/">{ this.props.termes.application.membreDashboard}</NavLink>
                <NavLink  activeClassName={classes.active} to="/marks/">{ this.props.termes.application.membreMarks}</NavLink>
                <NavLink  activeClassName={classes.active} to="/jewels/">{ this.props.termes.application.membreJewels}</NavLink>
                <NavLink  activeClassName={classes.active} to="/contact/">{ this.props.termes.application.membreContact}</NavLink>
                <NavLink className={ classes.accountlink } style={{ backgroundImage: "url("+bgAccount+")"  }}  activeClassName={classes.active} to="/account/"> { this.props.termes.application.membreAccount}</NavLink>
                <button className={ classes.accountlink } style={{ backgroundImage: "url("+bgLogout+")"  }} onClick={()=> {  this.props.history.push('/login'); this.props.doLogout(); } }>Logout</button>
            </nav>
            <Media query={{ maxWidth: 751 }}>
       
                    { matches => (  <Fragment> { matches ? 
            <Burger onClick={() => { this.props.burgerClick(); } } active={this.props.burgerActive } marginTop='0px' />
            :null}</Fragment>
                    )}
            </Media>
        </header>
        )
    }
}


 const mapStateToProps = (state)=>{
    return {
        termes: state.settings.termes
    }
  };
  
  
  export default connect(mapStateToProps, {doLogout})(withRouter(Toolbar));

